import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { ChooseWorkspaceController } from "./choose-workspace-controller";
import { ChooseWorkspacePage } from "./choose-workspace-page";

export function ChooseWorkspaceRoute({ deps }: { deps: AppDeps }) {
  return (
    <Subtree
      key="choose-workspace"
      controller={() =>
        new ChooseWorkspaceController(
          pick(
            deps,
            "client",
            "authHandler",
            "storeRepository",
            "reviewQueueRepository",
            "customersRepository",
            "pendingCartsRepository",
          ),
        )
      }
    >
      <ChooseWorkspacePage />
    </Subtree>
  );
}
